<template>
  <div class="contactUs">
    <header-wrapper></header-wrapper>
    <div class="contentTitle contactUsTitle">
      <p class="name">联系我们</p>
      <p class="desc">EMPLOYEE WELFARE</p>
    </div>
    <div class="contentWrapper" >
      <ul>
        <li class="animate__fadeInUp animate__animated">
          <img src="../../assets/img/gps.png" alt="" class="gps">
          <div class="desc">
            <p>地址：广州市天河区花城大道769号广州嘉昱中心17层1701室</p>
            <p>乘车：地铁5号线潭村站C出口</p>
            <p>电话：020-89637319</p>
          </div>
        </li>
        <li class="animate__fadeInUp animate__animated">
          <img src="../../assets/img/bag.png" alt="" class="gps">
          <div class="desc">
            <p>商务合作：15521282678（微信同号）</p>
            <p>商务邮箱：cheney@9snail.com</p>
            <p>流量合作：13249165326（微信同号）</p>
            <p>流量合作邮箱：aif@9snail.com</p>
            <p>HR邮箱：hrsnail@9snail.com</p>
          </div>
        </li>
      </ul>
    </div>
    <footer-wrapper></footer-wrapper>
  </div>
</template>
<script>
import headerWrapper from '@/components/header'
import footerWrapper from '@/components/footer'
export default {
  name: 'ContactUs',
  components: { headerWrapper, footerWrapper }
}
</script>
<style scoped lang="scss">
  .contactUs{
    background: url("../../assets/img/contactUsBg.png") no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 1075px;
    .contactUsTitle{
      padding: 106px 0 85px 0;
    }
    .contentWrapper{
      text-align: center;
      margin-bottom: 110px;
      ul{
        li{
          text-align: center;
          display: inline-block;
          margin-right: 81px;
          width: 680px;
          /* height: 412px; */
          background: #FFFFFF;
          border: 1px solid #CCCCCC;
          border-radius: 24px;
          padding: 75px 0;
          &:last-child{
            margin-right: 0px;
          }
          img{
            display: inline-block;
            //margin-top: 123px;
          }
          p{
            font-size: 18px;
            //font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin-bottom: 28px;
          }
        }
      }

    }
    .contentWrapper{
      ul{
        li{
          &:last-child{
            padding: 75px 0 57px 0!important;
            vertical-align: top;
            p{
              margin-bottom: 10px;
            }
          }
        }
      }
    }

  }
</style>